function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Product Form Web Component: iamSellingPlanInput <iam-selling-plan-input>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// The Selling Plan Input is responsible for handling the selling plan selection UI.
// ----------------------------------------------------------------------------
// Event Listeners:
// - `productForm:variant:changed` → Dynamically refreshes selling plans on variant change
// ----------------------------------------------------------------------------
// Gotchas:
// - Unknown support with Preorders, multiple selling plan groups, or plans with >1 option input
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import iamFormElement from 'scripts/classes/iamFormElement';
import translate from 'scripts/helpers/iamota-translate';
import { Loadable } from 'scripts/classes/iamota-component-helpers';
import { formatMoney } from '@shopify/theme-currency';
import Debug from 'scripts/libs/debug';

// Styles
import './_selling-plan-input.scss';
class iamSellingPlanInput extends iamFormElement {
  constructor() {
    var _window, _window2, _window3, _window4, _window5, _window6, _window7, _window8, _window9, _window0;
    super();
    this.tabIndex = 0;
    this.addEventListener('keydown', this.handleKeydown.bind(this));
    this.loadable = new Loadable(this);
    this.sellingPlanGroups = [];
    this.selectedPlan = null;
    this.cartItem = null;
    this.cartContext = false;
    this.translations = {
      purchase_options: (_window = window) === null || _window === void 0 || (_window = _window.translations) === null || _window === void 0 ? void 0 : _window.sellingPlan.purchase_options,
      subscribe_no_savings: (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.translations) === null || _window2 === void 0 ? void 0 : _window2.sellingPlan.subscribe_no_savings,
      save_percentage: (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.translations) === null || _window3 === void 0 ? void 0 : _window3.sellingPlan.save_percentage,
      plan_label: (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.translations) === null || _window4 === void 0 ? void 0 : _window4.sellingPlan.plan_label,
      group_plan_label: (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.translations) === null || _window5 === void 0 ? void 0 : _window5.sellingPlan.group_plan_label,
      onetime: (_window6 = window) === null || _window6 === void 0 || (_window6 = _window6.translations) === null || _window6 === void 0 ? void 0 : _window6.sellingPlan.onetime,
      sellingplan: (_window7 = window) === null || _window7 === void 0 || (_window7 = _window7.translations) === null || _window7 === void 0 ? void 0 : _window7.sellingPlan.sellingplan,
      error: (_window8 = window) === null || _window8 === void 0 || (_window8 = _window8.translations) === null || _window8 === void 0 ? void 0 : _window8.sellingPlan.error,
      subscription_message_line_1: (_window9 = window) === null || _window9 === void 0 || (_window9 = _window9.translations) === null || _window9 === void 0 ? void 0 : _window9.sellingPlan.subscription_message_line_1,
      subscription_message_line_2: (_window0 = window) === null || _window0 === void 0 || (_window0 = _window0.translations) === null || _window0 === void 0 ? void 0 : _window0.sellingPlan.subscription_message_line_2
    };
  }
  getCurrentSellingPlan() {
    return this.selectedPlan || null;
  }
  onFormInit() {
    this.cartItem = this.closest('iam-cart-item');
    this.cartContext = Boolean(this.cartItem);
    if (!this.hasAttribute('data-no-input')) {
      this.hiddenInput = this.form.querySelector('input[name="selling_plan"]');
      if (!this.hiddenInput) {
        this.hiddenInput = document.createElement('input');
        this.hiddenInput.type = 'hidden';
        this.hiddenInput.name = 'selling_plan';
        this.hiddenInput.value = '';
        this.form.appendChild(this.hiddenInput);
      }
    }
    var initRefresh = () => this.refreshSellingPlans();
    if (this.cartItem && !this.cartItem.itemData) {
      var handler = () => {
        initRefresh();
        iamotaEventHandler.unsubscribe('cartForm:items:item:init', handler, {
          context: this.cartItem
        });
      };
      iamotaEventHandler.subscribe('cartForm:items:item:init', handler, {
        context: this.cartItem
      });
    } else {
      initRefresh();
    }
    iamotaEventHandler.subscribe('productForm:variant:changed', () => {
      this.refreshSellingPlans();
    }, {
      context: this.iamForm
    });
  }
  refreshSellingPlans() {
    this.loadable.setLoading(true);
    try {
      var currentData = this.cartItem ? this.cartItem.getCurrentData() : this.iamForm.getCurrentData();

      // Guard against missing product or variant data
      if (!(currentData !== null && currentData !== void 0 && currentData.product) || !(currentData !== null && currentData !== void 0 && currentData.variant)) {
        if (!this.cartItem) {
          this.showError(this.translations.error);
        }
        return;
      }
      this.hideSubscriptionPrice = this.dataset.hideSubscriptionPrice === 'true';
      this.sellingPlanGroups = this.preprocessSellingPlans(currentData);
      if (!this.sellingPlanGroups.length) {
        this.showError(this.translations.error);
        return;
      }
      this.render();
      this.bindEvents();
    } catch (error) {
      console.error('Selling Plan Processing Error:', error);
      this.showError(this.translations.error);
    } finally {
      this.loadable.setLoading(false);
    }
  }
  preprocessSellingPlans() {
    var currentData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var variant = currentData.variant,
      product = currentData.product;
    var groups = [];
    if (!variant || !product) {
      return groups;
    }
    if (!product.requires_selling_plan) {
      groups.push({
        id: 'onetime',
        name: this.translations.onetime,
        name_with_discount: this.translations.onetime,
        options: [],
        plans: [this.createOnetimePlan(variant)]
      });
    }
    (product.selling_plan_groups || []).forEach(group => {
      var discounts = group.selling_plans.map(plan => {
        var _plan$price_adjustmen;
        var adj = (_plan$price_adjustmen = plan.price_adjustments) === null || _plan$price_adjustmen === void 0 ? void 0 : _plan$price_adjustmen[0];
        return "".concat(adj.value_type, ":").concat(adj.value);
      });
      var uniqueDiscounts = [...new Set(discounts)];
      var commonDiscountAdj = uniqueDiscounts.length === 1 ? group.selling_plans[0].price_adjustments[0] : null;
      var nameWithDiscount = translate('{{ name }} {{ common_discount }}', 'sellingplan.group_label.sellingplan', _objectSpread(_objectSpread({}, group), {}, {
        common_discount: this.formatDiscountLabel(commonDiscountAdj)
      }));
      var plans = group.selling_plans.map(plan => {
        var _variant$selling_plan, _plan$price_adjustmen2;
        var allocation = (_variant$selling_plan = variant.selling_plan_allocations) === null || _variant$selling_plan === void 0 ? void 0 : _variant$selling_plan.find(a => a.selling_plan_id === plan.id);
        var adj = (_plan$price_adjustmen2 = plan.price_adjustments) === null || _plan$price_adjustmen2 === void 0 ? void 0 : _plan$price_adjustmen2[0];
        var purchaseType = plan.recurring_deliveries ? 'subscription' : 'selling_plan';
        var rawLabel = "".concat(plan.options[0].name, " ").concat(plan.options[0].value);
        var formattedDiscount = this.formatDiscountLabel(adj);
        return {
          id: plan.id,
          purchase_type: purchaseType,
          group_id: group.id,
          group_name: group.name,
          group_name_with_discount: nameWithDiscount,
          optionMapping: {
            [plan.options[0].name]: plan.options[0].value
          },
          label: rawLabel,
          label_with_discount: translate('{{ label }} (Save {{ formatted_discount }})', 'sellingPlan.plan_label', _objectSpread(_objectSpread({}, plan), {}, {
            label: rawLabel,
            formatted_discount: formattedDiscount
          })),
          name: plan.name || group.name,
          description: plan.description,
          discount: adj ? {
            value_type: adj.value_type,
            value: adj.value,
            name: formattedDiscount
          } : null,
          price: (allocation === null || allocation === void 0 ? void 0 : allocation.price) || variant.price,
          compare_at_price: (allocation === null || allocation === void 0 ? void 0 : allocation.compare_at_price) || variant.compare_at_price,
          per_delivery_price: (allocation === null || allocation === void 0 ? void 0 : allocation.per_delivery_price) || (allocation === null || allocation === void 0 ? void 0 : allocation.price) || variant.price,
          recurring_deliveries: plan.recurring_deliveries
        };
      });
      groups.push({
        id: group.id,
        name: group.name,
        name_with_discount: nameWithDiscount,
        options: group.options,
        plans: plans
      });
    });
    Debug.extreme('Processed Selling Plan Groups:', groups);
    return groups;
  }
  createOnetimePlan(variant) {
    return {
      id: null,
      purchase_type: 'onetime',
      group_id: 'onetime',
      group_name: this.translations.onetime,
      group_name_with_discount: this.translations.onetime,
      optionMapping: {},
      label: this.translations.onetime,
      label_with_discount: this.translations.onetime,
      name: this.translations.onetime,
      description: null,
      discount: null,
      price: variant.price,
      compare_at_price: variant.compare_at_price,
      per_delivery_price: variant.price,
      recurring_deliveries: false
    };
  }
  formatDiscountLabel(adj) {
    if (!adj) return '';
    if (adj.value_type === 'percentage') {
      return "".concat(adj.value, "%");
    }
    if (adj.value_type === 'fixed_amount') {
      return formatMoney(adj.value);
    }
    return adj.value;
  }
  updateDisplayedSubscriptionPrice(plan) {
    var priceSpan = this.querySelector('.js-plan-price');
    if (!priceSpan || !plan) return;
    if (this.hideSubscriptionPrice) return;
    var formattedPrice = formatMoney(plan.price || plan.price);
    var formattedCompare = plan.compare_at_price ? formatMoney(plan.compare_at_price) : null;
    if (formattedCompare && formattedCompare !== formattedPrice) {
      priceSpan.innerHTML = "<span class=\"price__original\">".concat(formattedPrice, "</span>");
    } else {
      priceSpan.textContent = formattedPrice;
    }
  }
  render() {
    var _this$cartItem;
    var noDropdowns = this.hasAttribute('data-no-dropdowns');
    var oneTimeGroup = this.sellingPlanGroups.find(g => g.id === 'onetime');
    var subscriptionGroups = this.sellingPlanGroups.filter(g => g.id !== 'onetime');
    var allSubscriptionPlans = subscriptionGroups.flatMap(g => g.plans);
    var idPrefix = ((_this$cartItem = this.cartItem) === null || _this$cartItem === void 0 || (_this$cartItem = _this$cartItem.itemData) === null || _this$cartItem === void 0 ? void 0 : _this$cartItem.key) || Math.random().toString(36).substr(2, 9);
    if (this.cartContext) {
      var _dropdownId = "selling-plan-dropdown-".concat(idPrefix);
      var optionsHtml = "\n                ".concat(oneTimeGroup ? "<option value=\"onetime\">".concat(oneTimeGroup.name, "</option>") : '', "\n                ").concat(allSubscriptionPlans.map(plan => "<option value=\"".concat(plan.id, "\">").concat(plan.group_name, "</option>")).join(''), "\n            ");
      this.innerHTML = "\n                <div class=\"selling-plan__dropdown-container\">\n                    <label class=\"selling-plan-dropdown__label\" for=\"".concat(_dropdownId, "\">").concat(this.translations.group_plan_label, "</label>\n                    <div class=\"selling-plan__dropdown-wrapper\">\n                        <select class=\"selling-plan__dropdown\" id=\"").concat(_dropdownId, "\">\n                            ").concat(optionsHtml, "\n                        </select>\n                    </div>\n                </div>\n            ");
      this.autoSelectDefaultPlan();
      return;
    }

    // Skip rendering if there's only one plan (e.g., only onetime or a single subscription)
    if (this.sellingPlanGroups.length === 1 && this.sellingPlanGroups[0].plans.length === 1) {
      this.selectedPlan = this.sellingPlanGroups[0].plans[0];
      if (this.hiddenInput) this.hiddenInput.value = this.selectedPlan.id || '';
      iamotaEventHandler.trigger("".concat(this.namespace, ":changed"), {
        sellingPlan: this.selectedPlan
      }, {
        context: this
      });
      this.updateProductPrice();
      return;
    }
    var html = '';
    var radioName = "purchase_type_".concat(idPrefix);
    var subscriptionId = "subscription_".concat(idPrefix);
    var onetimeId = "onetime_".concat(idPrefix);
    var dropdownId = "selling-plan-dropdown-".concat(idPrefix);
    if (allSubscriptionPlans.length > 0) {
      var firstPlan = allSubscriptionPlans[0];
      var formattedPrice = formatMoney(firstPlan.per_delivery_price || firstPlan.price);
      var formattedDiscountPercentage = firstPlan.label_with_discount.match(/Save (\d+%)/)[1];
      var saveText = '';
      if (firstPlan.discount.value > 0) saveText = "".concat(this.translations.save_percentage).concat(formattedDiscountPercentage);
      var isSavings = saveText && saveText.trim() !== '';

      //const formattedCompare = firstPlan.compare_at_price ? formatMoney(firstPlan.compare_at_price) : null;

      // Calculate subscription price with discount
      // const currentData = this.cartItem ? this.cartItem.getCurrentData() : this.iamForm.getCurrentData();
      // const variant = currentData?.variant;
      // const priceContainer = document.querySelector('iam-product-form .product__price');
      // const discountPercentage = priceContainer ? parseFloat(priceContainer.dataset.discountPercentage || 0) : 0;

      // let subscriptionPrice = firstPlan.per_delivery_price || firstPlan.price;
      // if (discountPercentage > 0 && variant) {
      //     subscriptionPrice = Math.round(variant.price * (1 - discountPercentage / 100));
      // }

      //const formattedPrice = formatMoney(subscriptionPrice);

      html += "\n                <div class=\"selling-plan__option\">\n                    <div class=\"selling-plan__details\">\n                        <input type=\"radio\" name=\"".concat(radioName, "\" value=\"subscription\" id=\"").concat(subscriptionId, "\">\n                        <div class=\"selling-plan__label-wrapper\">\n                            <label for=\"").concat(subscriptionId, "\">").concat(isSavings ? this.translations.purchase_options : this.translations.subscribe_no_savings, "</label>\n                            ").concat(isSavings ? "<span class=\"selling-plan__save text--body-small\">".concat(saveText, "</span>") : '', "\n                        </div>\n                        <span class=\"js-plan-price selling-plan__price\">").concat(this.hideSubscriptionPrice ? '' : formattedPrice, "</span>\n                    </div>\n\n                    <div class=\"selling-plan__message\">\n                        <p class=\"text--body-small\">\n                            <svg class=\"icon\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                <path d=\"M11.6093 2.57767C11.9657 2.24901 12.5392 2.25334 12.8899 2.58736C13.2406 2.92138 13.2359 3.45897 12.8796 3.78763L4.88403 11.1608L1.65117 8.17972C1.29484 7.85106 1.29019 7.31345 1.64084 6.97945C1.9915 6.64548 2.5651 6.64114 2.92146 6.96976L4.88403 8.77958L11.6093 2.57767Z\" fill=\"currentColor\"/>\n                            </svg>\n                            <span>").concat(this.translations.subscription_message_line_1, "</span>\n                        </p>\n                        <p class=\"text--body-small\">\n                            <svg class=\"icon\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                <path d=\"M11.6093 2.57767C11.9657 2.24901 12.5392 2.25334 12.8899 2.58736C13.2406 2.92138 13.2359 3.45897 12.8796 3.78763L4.88403 11.1608L1.65117 8.17972C1.29484 7.85106 1.29019 7.31345 1.64084 6.97945C1.9915 6.64548 2.5651 6.64114 2.92146 6.96976L4.88403 8.77958L11.6093 2.57767Z\" fill=\"currentColor\"/>\n                            </svg>\n                            <span>").concat(this.translations.subscription_message_line_2, "</span>\n                        </p>\n                    </div>\n\n                    ").concat(!noDropdowns ? "\n                        <div class=\"selling-plan__dropdown-container\">\n                            <label class=\"selling-plan-dropdown__label\" for=\"".concat(dropdownId, "\">").concat(this.translations.group_plan_label, "</label>\n                            <div class=\"selling-plan__dropdown-wrapper\">\n                                <select class=\"selling-plan__dropdown\" id=\"").concat(dropdownId, "\" data-group=\"subscription\" disabled aria-disabled=\"true\">\n                                    ").concat(allSubscriptionPlans.map(plan => "\n                                        <option value=\"".concat(plan.id, "\">").concat(plan.group_name, "</option>\n                                    ")).join(''), "\n                                </select>\n                            </div>\n                        </div>\n                    ") : '', "\n                </div>\n            ");
    }
    if (oneTimeGroup) {
      html += "\n                <div class=\"selling-plan__option one-time\">\n                    <div class=\"selling-plan__details\">\n                        <input type=\"radio\" name=\"".concat(radioName, "\" value=\"onetime\" id=\"").concat(onetimeId, "\">\n                        <label for=\"").concat(onetimeId, "\">").concat(this.translations.onetime, "</label>\n                        ").concat(oneTimeGroup.plans.map(plan => "\n                            <span class=\"selling-plan__price\">".concat(formatMoney(plan.price), "</span>\n                        ")).join(''), "\n                    </div>\n                </div>\n            ");
    }
    this.innerHTML = "\n            <div class=\"selling-plan\" role=\"radiogroup\" aria-label=\"".concat(this.translations.purchase_options, "\">\n                ").concat(html, "\n            </div>\n        ");
    if (noDropdowns) {
      var _this$selectedPlan;
      this.selectedPlan = allSubscriptionPlans[0] || (oneTimeGroup === null || oneTimeGroup === void 0 ? void 0 : oneTimeGroup.plans[0]) || null;
      if (this.hiddenInput) this.hiddenInput.value = ((_this$selectedPlan = this.selectedPlan) === null || _this$selectedPlan === void 0 ? void 0 : _this$selectedPlan.id) || '';
      iamotaEventHandler.trigger("".concat(this.namespace, ":changed"), {
        sellingPlan: this.selectedPlan
      }, {
        context: this
      });
      this.updateProductPrice();
    }
    this.autoSelectDefaultPlan();
  }
  bindEvents() {
    if (this.cartContext) {
      var _dropdown = this.querySelector('.selling-plan__dropdown');
      _dropdown === null || _dropdown === void 0 || _dropdown.addEventListener('change', () => {
        this.resolveSelectedPlan();
      });
      return;
    }
    var radios = this.querySelectorAll('input[type="radio"][name^="purchase_type_"]');
    var dropdown = this.querySelector('.selling-plan__dropdown');
    var noDropdowns = this.hasAttribute('data-no-dropdowns');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!noDropdowns && dropdown) {
          var isSubscription = radio.value === 'subscription';
          dropdown.disabled = !isSubscription;
          dropdown.setAttribute('aria-disabled', String(!isSubscription));
        }
        this.resolveSelectedPlan();
      });
    });
    if (!noDropdowns && dropdown) {
      dropdown.addEventListener('change', () => {
        this.resolveSelectedPlan();
      });
    }
  }
  resolveSelectedPlan() {
    var _this$selectedPlan2, _this$selectedPlan3;
    if (this.cartContext) {
      var dropdown = this.querySelector('.selling-plan__dropdown');
      var value = dropdown === null || dropdown === void 0 ? void 0 : dropdown.value;
      var _plan;
      if (value === 'onetime') {
        var group = this.sellingPlanGroups.find(g => g.id === 'onetime');
        _plan = group === null || group === void 0 ? void 0 : group.plans[0];
      } else {
        var allPlans = this.sellingPlanGroups.filter(g => g.id !== 'onetime').flatMap(g => g.plans);
        _plan = allPlans.find(p => p.id == value);
      }
      this.selectedPlan = _plan || null;
      iamotaEventHandler.trigger("".concat(this.namespace, ":changed"), {
        sellingPlan: this.selectedPlan
      }, {
        context: this
      });
      this.updateProductPrice();
      return;
    }
    var selectedRadio = this.querySelector('input[type="radio"][name^="purchase_type_"]:checked');
    if (!selectedRadio) return;
    var groupId = selectedRadio.value;
    var plan;

    // Reset selected class on all options
    this.querySelectorAll('.selling-plan__option').forEach(option => {
      option.classList.remove('is-selected');
    });

    // Add selected class to the chosen one
    var selectedOption = selectedRadio.closest('.selling-plan__option');
    if (selectedOption) {
      selectedOption.classList.add('is-selected');
    }
    if (groupId === 'onetime') {
      var _group = this.sellingPlanGroups.find(g => g.id === 'onetime');
      plan = _group === null || _group === void 0 ? void 0 : _group.plans[0];
    } else if (groupId === 'subscription') {
      var _allPlans = this.sellingPlanGroups.filter(g => g.id !== 'onetime').flatMap(g => g.plans);
      if (this.hasAttribute('data-no-dropdowns')) {
        plan = _allPlans[0];
      } else {
        var _dropdown2 = this.querySelector("select[data-group=\"subscription\"]");
        var selectedPlanId = _dropdown2 === null || _dropdown2 === void 0 ? void 0 : _dropdown2.value;
        plan = _allPlans.find(p => p.id == selectedPlanId);
      }
    }
    this.selectedPlan = plan || null;
    if (this.hiddenInput) this.hiddenInput.value = ((_this$selectedPlan2 = this.selectedPlan) === null || _this$selectedPlan2 === void 0 ? void 0 : _this$selectedPlan2.id) || '';
    iamotaEventHandler.trigger("".concat(this.namespace, ":changed"), {
      sellingPlan: this.hideSubscriptionPrice ? null : this.selectedPlan
    }, {
      context: this
    });

    // Update price span
    if (((_this$selectedPlan3 = this.selectedPlan) === null || _this$selectedPlan3 === void 0 ? void 0 : _this$selectedPlan3.purchase_type) === 'subscription') {
      this.updateDisplayedSubscriptionPrice(this.selectedPlan);
    }

    // Directly update the product price component
    this.updateProductPrice();
  }

  /**
   * Directly update the product price component and retain credit
   */
  updateProductPrice() {
    var _this$iamForm;
    var productPriceComponent = (_this$iamForm = this.iamForm) === null || _this$iamForm === void 0 ? void 0 : _this$iamForm.querySelector('iam-product-price');
    if (productPriceComponent && typeof productPriceComponent.updatePriceForSellingPlan === 'function') {
      var planForPriceUpdate = this.hideSubscriptionPrice ? null : this.selectedPlan;
      productPriceComponent.updatePriceForSellingPlan(planForPriceUpdate);
    }

    // Also update the retain credit amount
    this.updateRetainCredit();
  }

  /**
   * Update the retain credit display based on the selected selling plan
   */
  updateRetainCredit() {
    var _this$iamForm2, _this$selectedPlan4, _window1, _window10, _window11;
    var creditElement = document.querySelector('.product-info__item--retain-credit');
    if (!creditElement) return;
    var percentage = parseFloat(creditElement.dataset.retainCreditPercentage || 0);
    if (!percentage || percentage <= 0) return;
    var variant = (_this$iamForm2 = this.iamForm) === null || _this$iamForm2 === void 0 ? void 0 : _this$iamForm2.getCurrentVariant();
    if (!variant) return;

    // Calculate effective price (same logic as in product-form--retain-credit.js)
    var effectivePrice = variant.price;
    if (this.selectedPlan && this.selectedPlan.purchase_type === 'subscription') {
      var priceContainer = document.querySelector('iam-product-form .product__price');
      var discountPercentage = priceContainer ? parseFloat(priceContainer.dataset.discountPercentage || 0) : 0;
      if (discountPercentage > 0) {
        effectivePrice = Math.round(variant.price * (1 - discountPercentage / 100));
      } else if (this.selectedPlan.price) {
        effectivePrice = this.selectedPlan.price;
      }
    }

    // Calculate credit amount and format
    var creditAmount = effectivePrice * (percentage / 100);
    var formattedCredit = formatMoney(creditAmount);

    // Get purchase type text
    var purchaseType = ((_this$selectedPlan4 = this.selectedPlan) === null || _this$selectedPlan4 === void 0 ? void 0 : _this$selectedPlan4.purchase_type) === 'subscription' ? ((_window1 = window) === null || _window1 === void 0 || (_window1 = _window1.translations) === null || _window1 === void 0 || (_window1 = _window1.sellingPlan) === null || _window1 === void 0 ? void 0 : _window1.subscribe_and_save) || 'Subscribe & Save' : ((_window10 = window) === null || _window10 === void 0 || (_window10 = _window10.translations) === null || _window10 === void 0 || (_window10 = _window10.sellingPlan) === null || _window10 === void 0 ? void 0 : _window10.onetime) || 'One-time Purchase';

    // Update the display
    var translationTemplate = ((_window11 = window) === null || _window11 === void 0 || (_window11 = _window11.translations) === null || _window11 === void 0 ? void 0 : _window11.retainCreditAmountHtml) || 'You earn <b>{{ retain_credit_amount }}</b> in credit with {{ purchase_type }}';
    var creditText = translationTemplate.replace('{{ retain_credit_amount }}', formattedCredit).replace('{{ purchase_type }}', purchaseType);
    var textElement = creditElement.querySelector('[data-retain-credit-text]');
    if (textElement) {
      textElement.innerHTML = creditText;
    }
  }
  autoSelectDefaultPlan() {
    var _this$cartItem3;
    if (this.cartContext) {
      var _this$cartItem2;
      var dropdown = this.querySelector('.selling-plan__dropdown');
      if (!dropdown) return;
      var _currentPlanId = ((_this$cartItem2 = this.cartItem) === null || _this$cartItem2 === void 0 || (_this$cartItem2 = _this$cartItem2.itemData) === null || _this$cartItem2 === void 0 || (_this$cartItem2 = _this$cartItem2.selling_plan_allocation) === null || _this$cartItem2 === void 0 || (_this$cartItem2 = _this$cartItem2.selling_plan) === null || _this$cartItem2 === void 0 ? void 0 : _this$cartItem2.id) || null;
      if (_currentPlanId) {
        dropdown.value = _currentPlanId;
      } else {
        dropdown.value = 'onetime';
      }
      this.resolveSelectedPlan();
      return;
    }
    var currentPlanId = ((_this$cartItem3 = this.cartItem) === null || _this$cartItem3 === void 0 || (_this$cartItem3 = _this$cartItem3.itemData) === null || _this$cartItem3 === void 0 || (_this$cartItem3 = _this$cartItem3.selling_plan_allocation) === null || _this$cartItem3 === void 0 || (_this$cartItem3 = _this$cartItem3.selling_plan) === null || _this$cartItem3 === void 0 ? void 0 : _this$cartItem3.id) || null;
    var targetGroup;
    var targetPlan;
    if (currentPlanId) {
      var _targetGroup;
      // Cart item already has a plan selected—respect it.
      targetGroup = this.sellingPlanGroups.find(g => g.plans.some(p => p.id == currentPlanId));
      targetPlan = (_targetGroup = targetGroup) === null || _targetGroup === void 0 ? void 0 : _targetGroup.plans.find(p => p.id == currentPlanId);
    } else if (this.cartItem) {
      var _targetGroup2;
      // Editing a cart item without a subscription defaults to one-time purchase.
      targetGroup = this.sellingPlanGroups.find(g => g.id === 'onetime');
      targetPlan = (_targetGroup2 = targetGroup) === null || _targetGroup2 === void 0 ? void 0 : _targetGroup2.plans[0];
    } else {
      var _targetGroup3;
      // Product page: default to the first subscription plan, falling back to one-time.
      targetGroup = this.sellingPlanGroups.find(g => g.id !== 'onetime');
      targetPlan = (_targetGroup3 = targetGroup) === null || _targetGroup3 === void 0 ? void 0 : _targetGroup3.plans[0];
      if (!targetGroup) {
        var _targetGroup4;
        targetGroup = this.sellingPlanGroups.find(g => g.id === 'onetime');
        targetPlan = (_targetGroup4 = targetGroup) === null || _targetGroup4 === void 0 ? void 0 : _targetGroup4.plans[0];
      }
    }
    if (!targetGroup) return;

    // const targetValue = targetGroup.id === 'onetime' ? 'onetime' : 'subscription';
    var targetValue = document.querySelector('[data-subscription-default]').dataset.subscriptionDefault || 'subscription';
    var targetRadio = this.querySelector("input[type=\"radio\"][name^=\"purchase_type_\"][value=\"".concat(targetValue, "\"]"));
    if (targetRadio) {
      var _this$selectedPlan5;
      targetRadio.checked = true;
      if (targetValue === 'subscription' && !this.hasAttribute('data-no-dropdowns')) {
        var _dropdown3 = this.querySelector("select[data-group=\"subscription\"]");
        if (_dropdown3) {
          _dropdown3.disabled = false;
          _dropdown3.setAttribute('aria-disabled', 'false');
          if (targetPlan) _dropdown3.value = targetPlan.id;
        }
      }
      this.resolveSelectedPlan();
      if (((_this$selectedPlan5 = this.selectedPlan) === null || _this$selectedPlan5 === void 0 ? void 0 : _this$selectedPlan5.purchase_type) === 'subscription') {
        this.updateDisplayedSubscriptionPrice(this.selectedPlan);
      }
    }
  }
  handleKeydown(event) {
    if (event.target !== this) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    var radios = Array.from(this.querySelectorAll('input[type="radio"][name^="purchase_type_"]'));
    if (!radios.length) return;
    var currentIndex = radios.findIndex(r => r.checked);
    currentIndex = (currentIndex + 1) % radios.length;
    var nextRadio = radios[currentIndex];
    nextRadio.checked = true;
    nextRadio.dispatchEvent(new Event('change', {
      bubbles: true
    }));
    nextRadio.focus();
  }
  showError(message) {
    var _this$iamForm3;
    (_this$iamForm3 = this.iamForm) === null || _this$iamForm3 === void 0 || _this$iamForm3.setErrorState(message);
  }
}
customElements.define('iam-selling-plan-input', iamSellingPlanInput);
export default iamSellingPlanInput;